import http from "../../../core/utils/apis/api";

const getTrainingEvaluationScores = async (trainingId) => {
  try {
    const response = await http({
      method: 'GET',
      url: `trainingEvaluationScore/${trainingId}`
    });

    return response;
  } catch (e) {
    throw e;
  }
};

const getTrainingInforationsHeader = async (id) => {
  try {
    const response = await http({
      method: 'GET',
      url: `trainings/${id}`
    });

    return response;
  } catch (e) {
    throw e;
  }
};
const trainingEvaluationScoresService = {
    getTrainingEvaluationScores,
    getTrainingInforationsHeader
};

export default trainingEvaluationScoresService;